import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import Select from "react-select";
import _ from "lodash";
import RequiredSelect from "./RequiredSelect";
import { useFetch2 } from "components/utils/authenticatedHook";
import encryptRequest from "../../helpers/encryptationHelper";
import Swal from "sweetalert2";

function ExtremeExceptionsDetails(props) {
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2();
  const [{ response: responseDelete, error: errorDelete, isLoading: isLoadingDelete }, doDelete, sendErrorDelete] = useFetch2();
  const { details, readingTypeAndConditions, careProviderId } = props;
  const [activeTab, setActiveTab] = useState("1");
  const [formData, setFormData] = useState({
    name: details.name || "",
    readingType: details.readingType || "",
    readingSubType: details.readingSubType || [],
    conditionGroup: details.conditionGroup || [],
    condition: details.condition || "",
    valueProperty: details.valueProperty || "",
    extremeReadingPatientMessage: details.extremeReadingPatientMessage || "",
    extremeReadingCareProviderMessage: details.extremeReadingCareProviderMessage || "",
    extremeReadingOneHourCareProviderMessage: details.extremeReadingOneHourCareProviderMessage || "",
    notifyReadingOwner: details.notifyReadingOwner || ['inbox'],
    notifySelf: details.notifySelf || [],
    notifyStaff: details.notifyStaff || [],
    patients: details.sharedUsers || [],
  });
  // Patch min/max/value fields from details.value array
  useEffect(() => {
    if (Array.isArray(details.valueProperty)) {
      const patch = {};
      details.valueProperty.forEach(item => {
        if (item.id) {
          patch[`minValue_${item.id}`] = item.minValue || "";
          patch[`maxValue_${item.id}`] = item.maxValue || "";
          patch[`value_${item.id}`] = item.value || "";
          patch[`gainLossPerDay_${item.id}`] = item.gainLossPerDay || "";
        }
      });
      setFormData(prev => ({
        ...prev,
        ...patch,
      }));
    }
  }, [details.valueProperty]);

  const [formError, setFormError] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [deleteReuest, setDeleteReuest] = useState(false);

  useEffect(() => {
    if ((!isLoading && submitted)) {
      setSubmitted(false);
      if (props.reload) {
        props.reload(true);
      }
    }
    if ((!isLoadingDelete && deleteReuest)) {
      setDeleteReuest(false);
      if (props.reload) {
        props.reload(true);
      }
    }
  }, [isLoading, isLoadingDelete]);

  const analyzeByOptions = [
    { value: "between", label: "In Range" },
    { value: ">=", label: "Greater Than" },
    { value: "<=", label: "Less Than" },
  ];

  const analyzeByValue =
    typeof formData.condition === "object" && formData.condition
      ? formData.condition.value
      : formData.condition;

  const selectedSubTypes = Array.isArray(formData.readingSubType)
    ? formData.readingSubType
    : [];

  // Validation function
  const validateForm = (data = formData) => {
    const errors = {};
    if (!data.name || !data.name.trim()) errors.name = "Name is required";
    if (!data.readingType) errors.readingType = "Reading type is required";
    if (!data.readingSubType || data.readingSubType.length === 0)
      errors.readingSubType = "Reading Sub Type is required";
    if (!data.condition && data.readingType && data.readingType._id !== "5bb306382598931ffbd1b625") errors.condition = "Analyze type is required";
    if (selectedSubTypes.length > 0) {
      selectedSubTypes.forEach(sub => {
        const subValue = Array.isArray(data.valueProperty)
          ? data.valueProperty.find(v => v.readingSubTypeId === sub._id)
          : null;
         if(sub.reading == "5bb306382598931ffbd1b625"){
          if (!subValue?.gainLossPerDay) {
              errors[`analyzeValue_${sub._id}`] = "Weight is required";
          }
        }else{
        if (analyzeByValue === "between") {
          const min = parseFloat(subValue?.minValue);
          const max = parseFloat(subValue?.maxValue);

          if (!subValue?.minValue || !subValue?.maxValue) {
            errors[`analyzeValue_${sub._id}`] =
              "Both min and max values are required";
          } else if (isNaN(min) || isNaN(max)) {
            errors[`analyzeValue_${sub._id}`] =
            "Min and max values must be valid numbers";
          } else if (max <= min) {
            errors[`analyzeValue_${sub._id}`] =
              "Max value must be greater than Min value";
          }
        } else {
          if (!subValue?.value) {
            errors[`analyzeValue_${sub._id}`] = "Value is required";
          }
        }
        }
      });
    }


    if (
      (!data.patients || data.patients.length === 0) &&
      (!data.conditionGroup || data.conditionGroup.length === 0)
    ) {
      errors.patients = "Monitor patient is required";
    }
    if (
      !data.extremeReadingCareProviderMessage ||
      !data.extremeReadingCareProviderMessage.trim()
    ) {
      errors.extremeReadingCareProviderMessage =
        "Care Provider message is required";
    }
    if (
      !data.extremeReadingPatientMessage ||
      !data.extremeReadingPatientMessage.trim()
    ) {
      errors.extremeReadingPatientMessage = "Patient message is required";
    }
    if (
      !data.extremeReadingOneHourCareProviderMessage ||
      !data.extremeReadingOneHourCareProviderMessage.trim()
    ) {
      errors.extremeReadingOneHourCareProviderMessage =
        "One Hour Care Provider message is required";
    }
    if (!data.notifyReadingOwner || data.notifyReadingOwner.length === 0) {
      errors.notifyReadingOwner =
        "At least one notification method for Reading Owner is required";
    }
    if (!data.notifyStaff || data.notifyStaff.length === 0) {
      errors.notifyStaff =
        "At least one notification method for Self is required";
    }
    return errors;
  };

  function handleSubmit(event) {
    event.preventDefault();
    setSubmitted(true);
    const errors = validateForm();
    setFormError(errors);
    if (Object.keys(errors).length === 0) {
      const dataToSubmit = {
        name: formData.name,
        readingType: formData.readingType._id,
        readingSubType: formData.readingSubType.map((sub) => sub._id) || [],
        conditionGroup: formData.conditionGroup
          ? formData.conditionGroup.map((item) => item._id)
          : [],
        condition: analyzeByValue,
        valueProperty: formData.valueProperty,
        extremeReadingPatientMessage: formData.extremeReadingPatientMessage,
        extremeReadingCareProviderMessage:
          formData.extremeReadingCareProviderMessage,
        extremeReadingOneHourCareProviderMessage:
          formData.extremeReadingOneHourCareProviderMessage,
        notifyReadingOwner: formData.notifyReadingOwner,
        notifySelf: formData.notifySelf,
        notifyStaff: formData.notifyStaff,
        sharedUsers: formData.patients.map((item) => item._id)
      };
      doFetch({
        url: "/update-extreme-reading-expectation/" + encryptRequest(details?._id),
        method: "PUT",
        disableWait: true,
        query: careProviderId ? { careProviderId } : undefined,
        body: dataToSubmit,
      });
    }
  }

  if (!details) return null;

  function handleInputChange(e) {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      let arr = [...formData[name]];
      if (checked) {
        arr = _.union(arr, [value]);
      } else {
        arr = arr.filter((v) => v !== value);
      }
      setFormData((prev) => ({
        ...prev,
        [name]: arr,
      }));
      setFormError(validateForm({ ...formData, [name]: arr }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormError(validateForm({ ...formData, [name]: value }));
    }
  }

  function handleDelete() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this extreme expectation?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        setDeleteReuest(true)
        doFetch({
          url: "/delete-extreme-reading-expectation/" + encryptRequest(details?._id),
          method: "DELETE",
          disableWait: true,
          query: careProviderId ? { careProviderId } : undefined,
        });
      }
    })
  }

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Card>
          <CardHeader
            tag="h4"
            className="justify-content-center"
            style={{ background: "white" }}
          >
            <span className="text-center">
              {details.name || "Event Expectation Details"}
            </span>
            <>
              <button
                style={{ float: "right" }}
                type="button"
                className="btn btn-info ml-2 close-click-cls"
                onClick={handleDelete}
                disabled={isLoadingDelete}
              >
                {isLoadingDelete ? (
                  <i className="mdi mdi-loading mdi-spin mr-2" />
                ) : (
                  <i className="mdi mdi-close" style={{ fontSize: 20 }} />
                )}{""}Delete
              </button>
              <button
                name="submit"
                style={{ float: "right" }}
                className="btn btn-info ml-2 print-click-cls"
                disabled={isLoading}
              >
                {isLoading ? (
                  <i className="mdi mdi-loading mdi-spin mr-2" />
                ) : (
                  <i
                    className="mdi mdi-content-save"
                    style={{ fontSize: 20, marginRight: 5 }}
                  ></i>)}{""}Update
              </button>
            </>
          </CardHeader>
        </Card>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body project-tab pt-2" style={{ paddingBottom: 0 }}>
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={activeTab === "1" ? "active" : ""}
                      onClick={() => setActiveTab("1")}
                    >
                      GENERAL
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "2" ? "active" : ""}
                      onClick={() => setActiveTab("2")}
                    >
                      NOTIFICATIONS
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "3" ? "active" : ""}
                      onClick={() => setActiveTab("3")}
                    >
                      PATIENTS
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Col sm="12" className="grid-margin mt-5">
                        <FormGroup>
                          <Label for="exampleEmail">Expectation Name</Label>
                          <Input
                            className="input-date-filter"
                            type="text"
                            name="name"
                            id="exampleEmail"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Expectation Name"
                          />
                          {submitted && formError.name && (
                            <div style={{ color: "red" }}>{formError.name}</div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleSelect">Pick a Reading Type</Label>
                          <RequiredSelect
                            SelectComponent={Select}
                            getOptionLabel={(option) =>
                              option["description"] + " (" + option["abbrev"] + ")"
                            }
                            getOptionValue={(option) => option["_id"]}
                            options={
                              readingTypeAndConditions?.data?.readingType
                                ? readingTypeAndConditions.data.readingType
                                : []
                            }
                            value={formData.readingType}
                            onChange={(selectedOption) => {
                              setFormData({ ...formData, readingType: selectedOption, readingSubType: [], valueProperty : "", analyzeBy: "" });
                              setFormError(
                                validateForm({ ...formData, readingType: selectedOption })
                              );
                            }}
                          />
                          {submitted && formError.readingType && (
                            <div style={{ color: "red" }}>{formError.readingType}</div>
                          )}
                        </FormGroup>
                        {(formData.readingType && formData.readingType._id) !== "5bb306382598931ffbd1b625" && (<FormGroup>
                          <Label for="exampleSelect">Analyze By</Label>
                          <RequiredSelect
                            SelectComponent={Select}
                            options={analyzeByOptions}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            value={analyzeByOptions.find(opt => opt.value === formData.condition) || null}
                            onChange={(selectedOption) => {
                              // Remove all minValue_*, maxValue_*, value_* keys from formData
                              const cleanedFormData = Object.keys(formData).reduce(
                                (acc, key) => {
                                  if (
                                    !key.startsWith("minValue_") &&
                                    !key.startsWith("maxValue_") &&
                                    !key.startsWith("value_")
                                  ) {
                                    acc[key] = formData[key];
                                  }
                                  return acc;
                                },
                                {}
                              );
                              setFormData({
                                ...cleanedFormData,
                                condition: selectedOption.value,
                                value: "",
                                minValue: "",
                                maxValue: "",
                              });
                              setFormError(
                                validateForm({
                                  ...cleanedFormData,
                                  condition: selectedOption.value,
                                  value: "",
                                  minValue: "",
                                  maxValue: "",
                                })
                              );
                            }}
                          />
                          {submitted && formError.condition && (
                            <div style={{ color: "red" }}>{formError.condition}</div>
                          )}
                        </FormGroup>)}
                        <FormGroup>
                          <Label for="exampleSelect">Pick a Readingsub Type</Label>
                          <RequiredSelect
                            SelectComponent={Select}
                            getOptionLabel={(option) =>
                             (option["name"] == "Beats Per Minute(BPM)" ? "Heart Rate" : option["name"]) + " (" + option["abbrev"] + ")"
                            }
                            getOptionValue={(option) => option["_id"]}
                            options={
                              readingTypeAndConditions?.data?.readingSubType &&
                                formData.readingType
                                ? readingTypeAndConditions.data.readingSubType.filter(
                                  (sub) =>
                                    sub.reading ===
                                    (formData.readingType._id || formData.readingType)
                                )
                                : []
                            }
                            isMulti={true}
                            closeMenuOnSelect={false}
                            value={formData.readingSubType}
                            onChange={(selectedOptions) => {
                              setFormData({
                                ...formData,
                                readingSubType: selectedOptions,
                              });
                              setFormError(
                                validateForm({
                                  ...formData,
                                  readingSubType: selectedOptions,
                                })
                              );
                            }}
                          />
                          {submitted && formError.readingSubType && (
                            <div style={{ color: "red" }}>{formError.readingSubType}</div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label>Reading Sub Type & Analyze Value</Label>
                          {selectedSubTypes.length === 0 && (
                            <div className="text-muted" style={{ fontSize: 15 }}>
                              Please select at least one Reading Sub Type.
                            </div>
                          )}
                          {selectedSubTypes.map((sub, idx) => (
                            <div
                              key={sub._id || idx}
                              className="d-flex align-items-center mb-2"
                              style={{ gap: 12 }}
                            >
                              <span style={{ minWidth: 180 }}>
                                {(sub.name === "Beats Per Minute(BPM)" || sub.name === "pulseRate") ? "Heart Rate" : sub.name === "Body Weight" ? "Body Weight (Gain Loss Per Day)" : sub.name} ({sub.abbrev})
                              </span>
                              {(formData.readingType && formData.readingType._id) == "5bb306382598931ffbd1b625" ? (
                                <Input
                                  type="text"
                                  className="input-date-filter"
                                  placeholder="Weight"
                                  min={0}
                                  value={
                                    Array.isArray(formData.valueProperty)
                                      ? formData.valueProperty.find(obj => obj.readingSubTypeId === sub._id)?.gainLossPerDay ?? ""
                                      : ""
                                  }
                                  onChange={e => {
                                    const newMin = e.target.value.replace(/[^0-9]/g, "");
                                    setFormData(prev => {
                                      const updatedValue = Array.isArray(prev.valueProperty) ? [...prev.valueProperty] : [];
                                      const index = updatedValue.findIndex(obj => obj.readingSubTypeId === sub._id);

                                      if (index !== -1) {
                                        updatedValue[index].minValue = newMin;
                                      } else {
                                        updatedValue.push({
                                          readingSubTypeId: sub._id,
                                          gainLossPerDay: newMin,
                                          minValue: "",
                                          maxValue: "",
                                          value: "",
                                          name: sub.name,
                                        });
                                      }

                                      return {
                                        ...prev,
                                        valueProperty: updatedValue,
                                      };
                                    });
                                  }}
                                  style={{ width: 120 }}
                                />
                              ) : (
                              formData.condition === "between" ? (
                                <>
                                  <Input
                                    type="text"
                                    className="input-date-filter"
                                    placeholder="Min"
                                    min={0}
                                    value={
                                      Array.isArray(formData.valueProperty)
                                        ? formData.valueProperty.find(obj => obj.readingSubTypeId === sub._id)?.minValue ?? ""
                                        : ""
                                    }
                                    onChange={e => {
                                      const newMin = e.target.value.replace(/[^0-9]/g, "");
                                      setFormData(prev => {
                                        const updatedValue = Array.isArray(prev.valueProperty) ? [...prev.valueProperty] : [];
                                        const index = updatedValue.findIndex(obj => obj.readingSubTypeId === sub._id);

                                        if (index !== -1) {
                                          updatedValue[index].minValue = newMin;
                                        } else {
                                          updatedValue.push({
                                            readingSubTypeId: sub._id,
                                            minValue: newMin,
                                            maxValue: "",
                                            value: "",
                                            name: sub.name,
                                          });
                                        }

                                        return {
                                          ...prev,
                                          valueProperty: updatedValue,
                                        };
                                      });
                                    }}
                                    style={{ width: 100 }}
                                  />
                                  <span style={{ margin: "0 6px" }}>to</span>
                                  <Input
                                    type="text"
                                    className="input-date-filter"
                                    placeholder="Max"
                                    min={0}
                                    value={
                                      Array.isArray(formData.valueProperty)
                                        ? formData.valueProperty.find(obj => obj.readingSubTypeId === sub._id)?.maxValue ?? ""
                                        : ""
                                    }
                                    onChange={e => {
                                      const newMax = e.target.value.replace(/[^0-9]/g, "");
                                      setFormData(prev => {
                                        const updatedValue = Array.isArray(prev.valueProperty) ? [...prev.valueProperty] : [];
                                        const index = updatedValue.findIndex(obj => obj.readingSubTypeId === sub._id);

                                        if (index !== -1) {
                                          updatedValue[index].maxValue = newMax;
                                        } else {
                                          updatedValue.push({
                                            readingSubTypeId: sub._id,
                                            maxValue: newMax,
                                            minValue: "",
                                            value: "",
                                            name: sub.name,
                                          });
                                        }

                                        return {
                                          ...prev,
                                          valueProperty: updatedValue,
                                        };
                                      });
                                    }}
                                    style={{ width: 100 }}
                                  />
                                </>
                              ) : (
                                <Input
                                  type="text"
                                  className="input-date-filter"
                                  placeholder="Value"
                                  min={0}
                                  value={
                                    Array.isArray(formData.valueProperty)
                                      ? formData.valueProperty.find(obj => obj.readingSubTypeId === sub._id)?.value ?? ""
                                      : ""
                                  }
                                  onChange={e => {
                                    const newValue = e.target.value.replace(/[^0-9]/g, "");
                                    setFormData(prev => {
                                      const updatedValue = Array.isArray(prev.valueProperty) ? [...prev.valueProperty] : [];
                                      const index = updatedValue.findIndex(obj => obj.readingSubTypeId === sub._id);

                                      if (index !== -1) {
                                        updatedValue[index].value = newValue;
                                      } else {
                                        updatedValue.push({
                                          readingSubTypeId: sub._id,
                                          value: newValue,
                                          minValue: "",
                                          maxValue: "",
                                          name: sub.name,
                                        });
                                      }

                                      return {
                                        ...prev,
                                        valueProperty: updatedValue,
                                      };
                                    });
                                  }}
                                  style={{ width: 120 }}
                                />
                              ))}
                              {submitted && formError[`analyzeValue_${sub._id}`] && (
                                <div style={{ color: "red" }}>
                                  {formError[`analyzeValue_${sub._id}`]}
                                </div>
                              )}
                            </div>
                          ))}
                        </FormGroup>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col sm="12" className="grid-margin mt-5">
                        <FormGroup>
                          <Label for="exampleText">
                            Extreme Notification Message (Patient)
                          </Label>
                          <Input
                            className="input-date-filter"
                            type="textarea"
                            name="extremeReadingPatientMessage"
                            value={formData.extremeReadingPatientMessage}
                            onChange={handleInputChange}
                            rows={10}
                          />
                          {submitted && formError.extremeReadingPatientMessage && (
                            <div style={{ color: "red" }}>
                              {formError.extremeReadingPatientMessage}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleText">
                            Extreme Notification Message (Careprovider)
                          </Label>
                          <Input
                            className="input-date-filter"
                            type="textarea"
                            name="extremeReadingCareProviderMessage"
                            value={formData.extremeReadingCareProviderMessage}
                            onChange={handleInputChange}
                            rows={10}
                          />
                          {submitted && formError.extremeReadingCareProviderMessage && (
                            <div style={{ color: "red" }}>
                              {formError.extremeReadingCareProviderMessage}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleText">
                            One Hour Remind Extreme Notification Message (Careprovider)
                          </Label>
                          <Input
                            className="input-date-filter"
                            type="textarea"
                            name="extremeReadingOneHourCareProviderMessage"
                            value={formData.extremeReadingOneHourCareProviderMessage}
                            onChange={handleInputChange}
                            rows={10}
                          />
                          {submitted && formError.extremeReadingOneHourCareProviderMessage && (
                            <div style={{ color: "red" }}>
                              {formError.extremeReadingOneHourCareProviderMessage}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleCheckbox">Notify Me</Label>
                          <div>
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline"
                              name="notifySelf"
                              onChange={handleInputChange}
                              value="inbox"
                              label="INBOX"
                              inline
                              checked={_.includes(formData.notifySelf, "inbox")}
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline2"
                              name="notifySelf"
                              checked={_.includes(formData.notifySelf, "sms")}
                              onChange={handleInputChange}
                              label="SMS"
                              value="sms"
                              inline
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline3"
                              name="notifySelf"
                              checked={_.includes(formData.notifySelf, "voice")}
                              onChange={handleInputChange}
                              label="VOICE"
                              value="voice"
                              inline
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline4"
                              name="notifySelf"
                              checked={_.includes(formData.notifySelf, "email")}
                              onChange={handleInputChange}
                              label="EMAIL"
                              value="email"
                              inline
                            />
                          </div>
                          {submitted && formError.notifySelf && (
                            <div style={{ color: "red" }}>{formError.notifySelf}</div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleCheckbox">Notify Staff</Label>
                          <div>
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline10"
                              name="notifyStaff"
                              value="inbox"
                              label="INBOX"
                              inline
                              onChange={(e) => {
                                handleInputChange(e);
                              }}
                              checked={_.includes(formData.notifyStaff, "inbox")}
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline11"
                              name="notifyStaff"
                              label="SMS"
                              value="sms"
                              inline
                              onChange={(e) => {
                                handleInputChange(e);
                              }}
                              checked={_.includes(formData.notifyStaff, "sms")}
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline12"
                              name="notifyStaff"
                              label="VOICE"
                              value="voice"
                              inline
                              onChange={(e) => {
                                handleInputChange(e);
                              }}
                              checked={_.includes(formData.notifyStaff, "voice")}
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline13"
                              name="notifyStaff"
                              label="EMAIL"
                              value="email"
                              inline
                              onChange={(e) => {
                                handleInputChange(e);
                              }}
                              checked={_.includes(formData.notifyStaff, "email")}
                            />
                          </div>
                          {submitted && formError.notifyStaff && (
                            <div style={{ color: "red" }}>
                              {formError.notifyStaff}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleCheckbox">
                            Notify Readings Owner
                          </Label>
                          <div>
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline6"
                              name="notifyReadingOwner"
                              value="inbox"
                              checked={_.includes(formData.notifyReadingOwner, "inbox")}
                              label="INBOX"
                              inline
                              onChange={handleInputChange}
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline7"
                              name="notifyReadingOwner"
                              checked={_.includes(formData.notifyReadingOwner, "sms")}
                              onChange={handleInputChange}
                              label="SMS"
                              value="sms"
                              inline
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline8"
                              name="notifyReadingOwner"
                              label="VOICE"
                              checked={_.includes(formData.notifyReadingOwner, "voice")}
                              onChange={handleInputChange}
                              value="voice"
                              inline
                            />
                            <CustomInput
                              type="checkbox"
                              id="exampleCustomInline9"
                              name="notifyReadingOwner"
                              label="EMAIL"
                              value="email"
                              checked={_.includes(formData.notifyReadingOwner, "email")}
                              onChange={handleInputChange}
                              inline
                            />
                          </div>
                          {submitted && formError.notifyReadingOwner && (
                            <div style={{ color: "red" }}>
                              {formError.notifyReadingOwner}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Col sm="12" className="grid-margin mt-5">
                        <>
                          <FormGroup>
                            <Label for="exampleSelect">
                              Select a Condition to Monitor
                            </Label>
                            <Select
                              value={Array.isArray(formData.conditionGroup) ? formData.conditionGroup : []}
                              onChange={(selectedOption) => {
                                setFormData({ ...formData, conditionGroup: selectedOption });
                                setFormError(
                                  validateForm({ ...formData, conditionGroup: selectedOption })
                                );
                              }}
                              options={
                                readingTypeAndConditions && readingTypeAndConditions.data && readingTypeAndConditions.data.condition
                                  ? readingTypeAndConditions.data.condition
                                  : []
                              }
                              isMulti={true}
                              getOptionLabel={(option) =>
                                `${option["condition"]}  (${option["description"]})`
                              }
                              getOptionValue={(option) => option["_id"]}
                            />
                            {submitted && formError.conditionGroup && (
                              <div style={{ color: "red" }}>{formError.conditionGroup}</div>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label for="exampleSelect">
                              Select a Patient to Monitor
                            </Label>
                            <Select
                              value={Array.isArray(formData.patients) ? formData.patients : []}
                              onChange={(selectedOption) => {
                                setFormData({ ...formData, patients: selectedOption });
                                setFormError(
                                  validateForm({ ...formData, patients: selectedOption })
                                );
                              }}
                              options={
                                readingTypeAndConditions && readingTypeAndConditions.data && readingTypeAndConditions.data.patients
                                  ? readingTypeAndConditions.data.patients
                                  : []
                              }
                              isMulti={true}
                              getOptionLabel={(option) =>
                                option["fname"] + " " + option["lname"]
                              }
                              getOptionValue={(option) => option}
                            />
                            {submitted && formError.patients && (
                              <div style={{ color: "red" }}>{formError.patients}</div>
                            )}
                          </FormGroup>
                        </>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        </div>
        <div className="row" />
      </Form>
    </div>
  );
}

export default ExtremeExceptionsDetails;